import request from '@/router/axios';

const getBaseList = () => request({
  url: '/api/mcc-base/holiday/base-list',
  method: 'get',
})

const getSchemeList = (current, size, params) => request({
  url: '/api/mcc-base/holiday/scheme-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getHolidayList = (current, size, params) => request({
  url: '/api/mcc-base/holiday/holiday-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getWorkerHolidayList = (current, size, params) => request({
  url: '/api/mcc-base/holiday/scheme-list?status=1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/holiday/create-scheme',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-base/holiday/remove-scheme',
  method: 'post',
  params: {
    ids,
  },
})

const createHoliday = params => request({
  url: '/api/mcc-base/holiday/create-holiday',
  method: 'post',
  params: { ...params },
})

const updateScheme = params => request({
  url: '/api/mcc-base/holiday/update-scheme',
  method: 'post',
  data: params,
})

const updateHoliday = params => request({
  url: '/api/mcc-base/holiday/update-holiday',
  method: 'post',
  data: params,
})

export default {
  getBaseList,
  getSchemeList,
  getHolidayList,
  getWorkerHolidayList,
  add,
  remove,
  createHoliday,
  updateScheme,
  updateHoliday,
};
